<script>
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { library } from '@fortawesome/fontawesome-svg-core';
import { faFloppyDisk } from '@fortawesome/free-solid-svg-icons';

library.add(faFloppyDisk);

export default {
  name: 'FirmwareUpdateBadge',
  components: { FontAwesomeIcon },
  props: {
    viaUsb: { type: Boolean, default: false },
  },
};
</script>

<template>
  <span class="badge badge-outline badge-accent firmware-update-badge">
    <FontAwesomeIcon :icon="['fas', 'floppy-disk']" class="mr-1 shrink-0" />
    <template v-if="viaUsb">Update available. Connect via USB to install</template>
    <template v-else>Update available. Connect to install</template>
  </span>
</template>

<style scoped>
/* daisyUI's .badge assumes single-line content: fixed height, no wrapping
   allowance. This label is a full sentence and does wrap at narrow widths,
   so let the pill grow instead of clipping/overflowing the wrapped line. */
.firmware-update-badge {
  height: auto;
  min-height: 1.5rem;
  padding-block: 0.25rem;
  white-space: normal;
  text-align: center;
  cursor: default;
  /* Match the buttons' corner radius (--radius-field) rather than daisyUI's
     pill default (--radius-selector) so the badge and the Update Firmware
     buttons read as the same component family. */
  border-radius: var(--radius-field);
}
</style>

